import { buildGetApiClient } from '@b-stock/fe-core/bstock-next/queries'
import { AllListingsApi as SearchApi } from '@b-stock/search-api-client'

const getAllListingsSearchClient = buildGetApiClient('SEARCH', SearchApi)

export default getAllListingsSearchClient
